import { useCallback, useEffect, useRef } from 'react';
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
import { useDeleteClinicTrialDemoWrapper } from 'src/Utils/Hooks/useDeleteTrialDemo/useDeleteTrialDemoWrapper';
import SmallDialog from 'src/SharedComponents/SmallDialog/SmallDialog';

interface IDeleteTrialDemoParams {
    entitlementId: string;
    distributorName: string;
    licenseType: string;
    distributorId: string;
    updateLicenses: () => void;
    onClose: () => void
}
const DeleteTrialDemo: React.FC<IDeleteTrialDemoParams> = ({ entitlementId, distributorName, licenseType, distributorId, updateLicenses, onClose }) => {
    const wrapperRef = useRef<HTMLDivElement>(null);
    const {deleteClinic, requestResponse, requestError} = useDeleteClinicTrialDemoWrapper();
    useOutsideClick(wrapperRef, () => { close() })
    useEffect(() => {
        if(requestResponse){
            updateLicenses();
            onClose();
        }
    }, [requestResponse, updateLicenses, onClose])
    useEffect(()=>{
        if(requestError !== ''){
            onClose();
        }
    }, [requestError, onClose])
    const close = useCallback(() => {
        onClose();
    }, [onClose]);
    const submit = useCallback(() => {
        deleteClinic(entitlementId, distributorName, licenseType, distributorId);
    }, [entitlementId, distributorName, licenseType, distributorId, deleteClinic]);
    const type = (licenseType: string) => licenseType.toLowerCase().includes("trial") ? 'Trail' : 'Demo';
    return (<>
        <div className='row'>
            <SmallDialog  
                onClose={() => { close() }}
                onSubmit={() => { submit() }}
                submitButtonText='Delete'
                title = {`Deleting ${type(licenseType)} Licence`}
                submitButtonColor='red'
                submitButtonWidth='120px'
                cancelButtonWidth='120px'
                cancelButtonFontColor='black'
                cancelButtonBorderColor='black'
                cancelButtonFontWeight= "bold"
                >
                <span>{`The Aura ${type(licenseType).toLocaleLowerCase()} license will be unassigned`}</span>
                <br/>
                <span>{`and deleted from "${distributorName}".`}</span>
            </SmallDialog>
        </div>
    </>
    )
}
export default DeleteTrialDemo